<template>
  <v-row class="main-container">
    <dialog-manage-quotation
      v-if="dialogManageQuotation"
      :dialog="dialogManageQuotation"
      v-model="selectedQuotation"
      v-on:dialog-close="onDialogManageQuotationClose"
    ></dialog-manage-quotation>

    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>
    <v-alert v-model="alert" :type="alertType" dismissible>{{
      alertMessage
    }}</v-alert>

    <v-row no-gutters class="px-2">
      <v-col>
        <v-subheader class="headline pl-0 ml-0" style="color: #1976d2"
          >Admin Board Notifications</v-subheader
        >
      </v-col>

      <!-- <v-col cols="2" class="d-flex justify-center pt-1">
        <v-autocomplete
          class="form-control rounded-0"
          :items="senders"
          placeholder="Select sender"
          return-object
          v-model="selected_sender"
          clearable
          item-text="name"
          solo
        ></v-autocomplete>
      </v-col> -->

      <v-col class="d-flex justify-content-end">
        <v-btn
          x-small
          class="caption px-0 pt-5"
          color="primary"
          text
          @click="markAllAsRead()"
          >Mark all as read</v-btn
        >
      </v-col>
    </v-row>

    <v-row>
      <v-divider class="mt-0"></v-divider>
    </v-row>

    <v-row dense>
      <v-col>
        <template v-for="(item, id) in admin_board_items">
          <v-card :key="id" flat tile color="white" class="px-1">
            <template v-if="new_notifications(item, id)">
              <v-card-title
                class="font-weight-bold caption primary--tex py-0 px-0"
                >NEW</v-card-title
              >
              <v-divider class="my-0"></v-divider>
            </template>

            <template v-if="earlier_notifications(item, id)">
              <v-card-title
                class="font-weight-bold caption primary--text py-0 px-0"
                >EARLIER</v-card-title
              >
              <v-divider class="my-0"></v-divider>
            </template>

            <template v-if="yesterday_notifications(item, id)">
              <v-card-title
                class="font-weight-bold caption primary--text py-0 px-0"
                >YESTERDAY</v-card-title
              >
              <v-divider class="my-0"></v-divider>
            </template>

            <template v-if="later_notifications(item, id)">
              <v-card-title
                class="font-weight-bold caption primary--text py-0 px-0"
                >LATER</v-card-title
              >
              <v-divider class="my-0"></v-divider>
            </template>

            <v-row no-gutters>
              <v-col>
                <v-card
                  flat
                  tile
                  class="py-1 px-1"
                  :color="!item.data.read ? '#EDF2FA' : 'white'"
                >
                  <v-row justify="space-between">
                    <span class="font-weight-bold caption black--text pl-12">
                      {{
                        item.data.sender.uid == `${$root.uid}`
                          ? "You"
                          : item.data.sender.first_name
                      }}
                      performed a {{ item.data.entity }}
                      {{ item.data.event }}</span
                    >

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          v-if="!item.data.read"
                          x-small
                          icon
                          color="grey"
                          class="pb-1"
                          @click="markAsRead(item)"
                        >
                          <v-icon size="15">mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      Mark as Read
                    </v-tooltip>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>
                      <v-row>
                        <div
                          :style="`background-color: ${
                            get_entity_type(item).color
                          }`"
                          class="rounded-icon mt-n4"
                        >
                          <v-icon
                            size="20"
                            class="d-flex"
                            style="padding-top: 6px"
                            color="white"
                            >{{ get_entity_type(item).icon }}</v-icon
                          >
                        </div>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <span
                              v-on="on"
                              style="cursor: pointer"
                              class="
                                font-weight-light
                                black--text
                                body-2
                                ml-4
                                pt-2
                              "
                              @click="onManageQuotation(item)"
                              >{{ item.data.message }} by
                              {{ item.data.sender.first_name }}</span
                            >
                          </template>
                          Click to open quotation
                        </v-tooltip>
                      </v-row>
                    </v-col>

                    <v-col>
                      <v-row justify="end" class="pt-1">
                        <span
                          class="
                            grey--text
                            text--darken-2
                            caption
                            text-lowercase
                            mr-2
                          "
                        >
                          {{ MOMENT(item.data.createdOnStr).fromNow() }}
                        </span>
                        <span
                          class="
                            grey--text
                            text--darken-2
                            caption
                            text-lowercase
                            ml-2
                          "
                          >by: {{ item.data.sender.first_name }}</span
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-divider class="my-1"></v-divider>
            </v-row>
          </v-card>
        </template>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-card flat color="white" tile>
          <v-card-text class="px-0 pt-0 pb-0"> </v-card-text>

          <v-card-actions class="pt-0">
            <v-row justify="center" v-if="admin_board_items.length >= 20">
              <v-btn
                small
                text
                class="font-weight-bold body-2 primary--text"
                @click="seeMore"
                >See More</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import constant from "../../const"
import moment from "moment"
import firebase from "firebase/app"
import DialogManageQuotation from "@/components/admin/dialogs/DialogManageQuotation"
export default {
  components: {
    DialogManageQuotation,
  },
  data() {
    return {
      MOMENT: moment,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 8000,
      alert: false,
      alertType: "success",
      alertMessage: "",
      // showAlert: false,

      selected: "ALL",
      selected_sender: null,

      senders: [
        {
          uid: "y4P9K5GkFcbRUyAt24eQh42Haw33",
          name: "Oscar",
        },
        {
          uid: "z2StmTx307VXsOKkf1A2QE8S5263",
          name: "Calvin",
        },
        {
          uid: "G3OTiTe48KWNsQZrOLv096GSekx1",
          name: "Isaac",
        },
      ],

      admin_board_items: [],
      admin_board_limit: 20,
      sender_admin_board_limit: 20,

      dialogManageQuotation: false,
      selectedQuotation: null,
    }
  },
  async created() {
    this.selected = "ALL"
    // verify user token
    await this.$root.verify_user_token()
  },
  mounted() {
    this.fetchAdminBoard()
  },
  watch: {
    selected_sender(newValue, oldValue) {
      if (newValue == null) {
        this.fetchAdminBoard()
      } else {
        this.fetchSenderAdminBoard()
      }
    },
  },

  methods: {
    /**
     * Fetch the admin board
     */
    fetchAdminBoard() {
      this.$root.blockUImsg = "Loading notifications"
      this.$root.blockUIshow = true

      this.selected = "ALL"
      // instantiate firestore
      var db = this.$root.messageCenterApp.firestore()

      // query the collection Group (admin board) and listen
      // order by createdOn and fetch by multiple of 20 records
      var self = this
      self.$root.fs_admin_board_listener = db
        .collectionGroup("admin_board")
        .where("owner", "==", self.$root.uid)
        .orderBy("createdOn", "desc")
        .limit(self.admin_board_limit)
        .onSnapshot((querySnapshot) => {
          // initialise admin board array
          self.admin_board_items = []
          querySnapshot.forEach((doc) => {
            self.admin_board_items.push({
              nid: doc.id,
              data: doc.data(),
            })
          })
        })

      this.$root.blockUIshow = false
    },

    /**
     * Fetch the selected sender admin board notifications
     */
    fetchSenderAdminBoard() {
      this.$root.blockUImsg = "Loading notifications"
      this.$root.blockUIshow = true

      this.selected = "SENDER"
      // instantiate firestore
      var db = this.$root.messageCenterApp.firestore()

      // query the collection Group (admin board) and listen
      // order by createdOn and fetch by multiple of 20 records
      var self = this
      self.$root.fs_admin_board_listener = db
        .collectionGroup("admin_board")
        .where("owner", "==", self.$root.uid)
        .where("sender.uid", "==", self.selected_sender.uid)
        .orderBy("createdOn", "desc")
        .limit(self.sender_admin_board_limit)
        .onSnapshot((querySnapshot) => {
          // initialise admin board array
          self.admin_board_items = []
          querySnapshot.forEach((doc) => {
            self.admin_board_items.push({
              nid: doc.id,
              data: doc.data(),
            })
          })
        })

      this.$root.blockUIshow = false
    },

    /**
     * Make admin board message as read
     */
    markAsRead(item) {
      item.data.read = true
      // instantiate firestore
      var db = this.$root.messageCenterApp.firestore()
      var self = this
      // update the read value to true
      db.collection("users")
        .doc(self.$root.uid)
        .collection("admin_board")
        .doc(item.nid)
        .update({
          read: true,
        })

      // decrement the admin_board_unread count by 1
      db.collection("users")
        .doc(self.$root.uid)
        .update({
          admin_board_unread: firebase.firestore.FieldValue.increment(-1),
        })
    },

    /**
     * Mark all as read
     */
    markAllAsRead() {
      // instantiate firestore
      var db = this.$root.messageCenterApp.firestore()
      var self = this

      // Collection group query for admin_board
      db.collectionGroup("admin_board")
        .where("owner", "==", self.$root.uid)
        .where("read", "==", false)
        .limit(500)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // update unread admin board messages to read
            db.collection("users")
              .doc(self.$root.uid)
              .collection("admin_board")
              .doc(doc.id)
              .update({
                read: true,
              })
          })
        })
        .catch((error) => {
          console.error("error fetching unread admin board messages: ", error)
        })

      // update the unread value to 0
      db.collection("users").doc(self.$root.uid).update({
        admin_board_unread: 0,
      })
    },

    /**
     * Fetch more admin board messages
     */
    seeMore() {
      if (this.selected == "ALL") {
        // increase the limit by 20
        this.admin_board_limit += 20
        this.fetchAdminBoard()
      } else {
        // increase the limit by 20
        this.sender_admin_board_limit += 20
        this.fetchSenderAdminBoard()
      }
    },

    /**
     * Entity Type
     */
    get_entity_type(item) {
      let icon = "mdi-bell"
      let color = "#212121" // grey darken-4

      switch (item.data.entity) {
        case "invoice":
          icon = "fa-file-invoice-dollar"
          color = "#4CAF50" // green
          break

        case "quotation":
          icon = "fa-file-invoice"
          color = "#607D8B" // blue-grey darken-4
          break

        case "booking":
          icon = "mdi-book"
          color = "#FF6F00" // amber darken-4
          break

        case "useraccount":
          icon = "mdi-account"
          color = "#1976D2" // primary
          break

        case "company":
          icon = "mdi-domain"
          color = "#64B5F6" // secondary
          break

        case "task":
          icon = "mdi-calendar-check"
          color = "#1B5E20" // green darken-4
          break

        case "email":
          icon = "mdi-email"
          color = "#2196F3" // blue
          break

        case "shipment":
          if (item.data.entity_type == "AIR") {
            icon = "mdi-airplane-takeoff"
            color = "#0091EA" // light-blue accent-4
          } else {
            icon = "mdi-ferry"
            color = "#01579B" // light-blue darken-4
          }
          break
        default:
          break
      }

      return { icon: icon, color: "#1976D2" }
    },

    /**
     * Find new admin board messages
     */
    new_notifications(item, index) {
      var spatt = /seconds/g
      var mpatt = /minute/g
      var ahpatt = /an hour/g
      var hpatt = /^\d\shour/g

      const timeago = moment(moment(item.data.createdOnStr)).fromNow(true)

      var sresult = timeago.match(spatt)
      var mresult = timeago.match(mpatt)
      var ahresult = timeago.match(ahpatt)
      var hresult = timeago.match(hpatt)
      if (
        index == 0 &&
        (sresult != null ||
          mresult != null ||
          ahresult != null ||
          hresult != null)
      ) {
        return true
      } else {
        return false
      }
    },

    /**
     * Find earlier notifications
     */
    earlier_notifications(item, index) {
      var patt = /^\d\d\shours/g

      const earlier = (obj) => {
        const timeago = moment(moment(obj.data.createdOnStr)).fromNow(true)

        var result = timeago.match(patt)
        if (result != null) {
          return true
        } else {
          return false
        }
      }

      // if prev is not earlier
      const prev = index - 1
      if (index > 0 && !earlier(this.admin_board_items[prev])) {
        return earlier(item)
      } else if (index == 0) {
        return earlier(item)
      } else {
        return false
      }
    },

    /**
     * Find yesterday notifications
     */
    yesterday_notifications(item, index) {
      var patt = /^a day/g
      const yesterday = (obj) => {
        const timeago = moment(moment(obj.data.createdOnStr)).fromNow(true)

        var result = timeago.match(patt)
        if (result != null) {
          return true
        } else {
          return false
        }
      }

      // if prev is not yesterday
      const prev = index - 1
      if (index > 0 && !yesterday(this.admin_board_items[prev])) {
        return yesterday(item)
      } else if (index == 0) {
        return yesterday(item)
      } else {
        return false
      }
    },

    /**
     * Find later notifications
     */
    later_notifications(item, index) {
      var days_patt = /days/g
      var month_patt = /month/g
      var year_patt = /year/g

      const later = (obj) => {
        const timeago = moment(moment(obj.data.createdOnStr)).fromNow(true)

        var days_result = timeago.match(days_patt)
        var month_result = timeago.match(month_patt)
        var year_result = timeago.match(year_patt)
        if (
          days_result != null ||
          month_result != null ||
          year_result != null
        ) {
          return true
        } else {
          return false
        }
      }

      // if prev is not later
      const prev = index - 1
      if (index > 0 && !later(this.admin_board_items[prev])) {
        return later(item)
      } else if (index == 0) {
        return later(item)
      } else {
        return false
      }
    },

    /**
     * on manage selected quotation
     */
    async onManageQuotation(quotation) {
      this.$root.blockUImsg = "Loading quotation information"
      this.$root.blockUIshow = true
      // verify user token
      await this.$root.verify_user_token()

      let resp = await this.$https.get(
        `/api/quotations/${quotation.data.quotation_id}`
      )

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // get the selected quotation
        this.selectedQuotation = resp.data.data
        this.dialogManageQuotation = true
      } else {
        console.log("OnManageQuotation Error: ", resp.data)
      }

      this.$root.blockUIshow = false
    },

    /**
     * On close Dialog Manage Quotation
     */
    onDialogManageQuotationClose(
      quotation,
      hasChange,
      isReAssigned = false,
      newCompany = null
    ) {
      this.dialogManageQuotation = false
      this.selectedQuotation = null
    },
  },
  computed: {},
}
</script>

<style scoped></style>
